import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { saveUserProfileAsync } from '../../../../actions/user.js';
import RightPanelBottom from './rightPanelBottom';
import RightPanelTop from './rightPanelTop';
import CenterPanel from './centerPanel';
import CenterPanelReadOnly from './centerPanelReadOnly';
import Modal from '../../../shared/modal/content';
import PopupHeader from '../../popupHeader';
import { updateShowUserProfileModal } from '../../../../actions/modal';
import { getUserBasicProfile } from 'actions/user';

const ProfileContent = (props) => {
  const centerPanelRef = useRef();
  const dispatch = useDispatch();
  const userProfile = useSelector((state) => state.usersReducer.userProfile);
  const isProfileImageEditable = useSelector((state) => state.usersReducer.isProfileImageEditable);
  const showChangeUserProfileModal = useSelector((state) => state.modalReducer.showChangeUserProfileModal);

  // useEffect(() => {
  //   setUserProfile(userProfile)
  // }, [props.userProfile])

  const saveUserProfile = () => {
    let saveCallBack = () => {
      dispatch(getUserBasicProfile());
      dispatch(updateShowUserProfileModal(false));
    };
    // take care the image
    if (isProfileImageEditable) {
      var base64 = centerPanelRef.current.getPictureBase64();
      var newUserProfile = Object.assign({}, userProfile, {
        userImageBase64: base64,
        userImageFileName: 'fake.jpg',
      });
      dispatch(saveUserProfileAsync(newUserProfile, saveCallBack));
    } else {
      dispatch(saveUserProfileAsync(userProfile, saveCallBack));
    }
  };

  let showModal = showChangeUserProfileModal || props.showOtherUsersProfileModal || false;
  return (
    <Modal show={showModal} hideWhenClickAway={false} className="ui modal reset-password">
      <PopupHeader
        hideHelp={props.updateOrView && props.updateOrView == 'view'}
        helpLink={APP.EXTERNAL_LINKS.MyProfile.Profile}
        title={
          props.updateOrView && props.updateOrView == 'view'
            ? APP.LANGUAGE.UserProfile.Title.replace(
                '##USERNAME##',
                props.selectedUser.firstName + ' ' + props.selectedUser.lastName
              ).replace('##PLURAL##', APP.LANGUAGE.UserProfile.TitlePlural)
            : APP.LANGUAGE.UserProfile.Title.replace('##USERNAME##', userProfile.displayNameInHeader).replace(
                '##PLURAL##',
                APP.LANGUAGE.UserProfile.TitlePlural
              )
        }
      />
      <div className="content">
        <div className="main-ui-container user-profile ">
          <div className="right ui rail">
            <div className="ui sticky user-profile-view">
              {props.updateOrView && props.updateOrView == 'view' ? (
                <RightPanelTop updateOrView={props.updateOrView} />
              ) : (
                <RightPanelTop onSave={saveUserProfile} />
              )}
              {props.updateOrView && props.updateOrView == 'view' ? (
                <RightPanelBottom updateOrView={props.updateOrView} />
              ) : (
                <RightPanelBottom />
              )}
            </div>
          </div>
          {props.updateOrView && props.updateOrView == 'view' ? (
            <CenterPanelReadOnly
              dispatch={dispatch}
              isAdmin={props.isAdmin}
              selectedUser={props.selectedUser}
              userCallsDetails={props.userCallsDetails}
            />
          ) : (
            <CenterPanel ref={centerPanelRef} />
          )}
          <div className="bottom-rail-with-left-and-right-content">
            {props.updateOrView && props.updateOrView == 'view' ? (
              <RightPanelTop updateOrView={props.updateOrView} />
            ) : (
              <RightPanelTop onSave={saveUserProfile} />
            )}
            {props.updateOrView && props.updateOrView == 'view' ? (
              <RightPanelBottom updateOrView={props.updateOrView} />
            ) : (
              <RightPanelBottom />
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ProfileContent;
